<script setup>
import { frames } from '../../../../utils/frames'
const gsapTimeline = useGsapTimeline()

const slots = useSlots()

const glowRedElement = ref(null)
const glowBlueElement = ref(null)
const ribbonElement = ref(null)

const hasSide = computed(() => Boolean(slots.side))

onMounted(() => {
  gsapTimeline({ name: 'InformationSurface Ambient', repeat: -1, yoyo: true })
    .to(glowRedElement, { x: 70, y: 45, scale: 1.08, duration: frames(280, 50), ease: 'sine.inOut' }, 0)
    .to(glowBlueElement, { x: -80, y: -35, scale: 0.94, duration: frames(320, 50), ease: 'sine.inOut' }, 0)
    .to(ribbonElement, { x: 28, y: -16, rotate: 5, duration: frames(300, 50), ease: 'sine.inOut' }, 0)
})
</script>

<template>
  <div class="size-full">
    <div class="relative size-full overflow-hidden bg-[#0a0e18] text-white">
      <div
        class="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(237,54,36,0.25),transparent_34%),radial-gradient(circle_at_88%_18%,rgba(30,100,200,0.28),transparent_30%),linear-gradient(155deg,rgba(30,40,60,0.2)_0%,rgba(20,30,50,0.4)_58%,rgba(10,15,30,0.6)_100%)]"
      />
      <div
        ref="ribbonElement"
        class="absolute -left-20 top-20 h-[14rem] w-[44rem] rotate-[-12deg] bg-[linear-gradient(90deg,rgba(237,54,36,0.35),rgba(50,70,120,0.1),rgba(30,100,200,0.35))] blur-2xl"
      />
      <div class="absolute right-20 top-5 flex gap-6 opacity-50">
        <div class="size-7 rounded-full bg-q-cr-red-primary" />
        <div class="size-8 rounded-full bg-joe-cr-blue-primary" />
      </div>
      <div ref="glowRedElement" class="absolute -left-24 top-[-8rem] h-[30rem] w-[30rem] rounded-full bg-q-cr-red-primary/40 blur-[135px]" />
      <div ref="glowBlueElement" class="absolute -right-24 bottom-[-8rem] h-[34rem] w-[34rem] rounded-full bg-joe-cr-blue-primary/45 blur-[145px]" />
      <div class="absolute bottom-20 left-16 h-40 w-40 rounded-full border-3 border-q-cr-red-primary/50 bg-q-cr-red-primary/25" />
      <div class="absolute top-1/3 right-12 h-52 w-52 rounded-full border-3 border-joe-cr-blue-primary/50 bg-joe-cr-blue-primary/20" />

      <slot name="full">
        <div class="relative z-0 size-full p-safe">
          <div class="flex size-full gap-12 rounded-[2.5rem] border-3 border-q-cr-red-primary/60 bg-[rgba(15,25,45,0.4)] p-14 shadow-[0_28px_90px_rgba(237,54,36,0.2)] backdrop-blur-md">
            <div class="min-w-0 flex-1">
              <slot />
            </div>
            <div v-if="hasSide" class="w-[34rem] shrink-0">
              <slot name="side" />
            </div>
          </div>
        </div>
      </slot>
    </div>
  </div>
</template>
